import { render, staticRenderFns } from "./topIndex.vue?vue&type=template&id=63e7570d&scoped=true&"
import script from "./topIndex.vue?vue&type=script&lang=js&"
export * from "./topIndex.vue?vue&type=script&lang=js&"
import style0 from "./topIndex.vue?vue&type=style&index=0&id=63e7570d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7570d",
  null
  
)

export default component.exports